// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sr2n","title":"styles_title___vlM6"};